/* eslint-disable promise/param-names */
import {
  AUTH_REQUEST,
  AUTH_HANDLE,
  AUTH_CHECK_SESSION,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT
} from "../actions/auth";
import { USER_REQUEST } from "../actions/user";
import apiCall from "@/api/apiCall";
import { apiUrl, baseUrl, clientId, pathname, loginUrl } from "@/api/apiUrl";

//import auth0 from "auth0-js";
import auth0 from '@/auth/authWrapper.js'

import router from "../../router/index.js";
import store from "..";

import axios from "axios";

const state = {
  userIsAuthorized: false,
  auth0: new auth0.WebAuth({
    domain: "mapcard.eu.auth0.com",
    clientID: clientId,
    redirectUri: baseUrl + "callback",
    responseType: "token id_token",
    scope: "openid profile email",
    prompt: "none"
  }),
  token: localStorage.getItem("Authorization-Token") || "",
  status: "",
  hasLoadedOnce: false,
  logoutUrl: loginUrl
};

const getters = {
  authStatus: state => state.status,
  authToken: state => state.token
};

const actions = {
  [AUTH_REQUEST]: () => {
    state.auth0.authorize();
  },
  [AUTH_HANDLE]: ({ commit }) => {
    state.auth0.parseHash((err, authResult) => {      
      if (authResult && authResult.idToken) {
        let expiresAt = JSON.stringify(
          authResult.expiresIn * 1000 + new Date().getTime()
        );

        localStorage.setItem("Authorization-Token", authResult.idToken);
        localStorage.setItem("expires_at", expiresAt);

        if ( authResult.logoutUrl ) {
          commit('SET_LOGIUT_URL', authResult.logoutUrl )
        }

        axios.defaults.headers.common["Authorization-Token"] =
          authResult.idToken;

        store.dispatch("USER_REQUEST");

        router.push({
          name: "Orders"
        });
      } else if (err) {
        store.dispatch("AUTH_LOGOUT");
        console.log(err);
      }
    });
  },
  [AUTH_CHECK_SESSION]: () =>
    new Promise((reject, resolve) => {
      state.auth0.checkSession({}, (err, authResult) => {
        console.log(err);
        if (authResult && authResult.idToken) {
          let expiresAt = JSON.stringify(
            authResult.expiresIn * 1000 + new Date().getTime()
          );

          localStorage.setItem("Authorization-Token", authResult.idToken);
          localStorage.setItem("expires_at", expiresAt);

          axios.defaults.headers.common["Authorization-Token"] =
            authResult.idToken;
          resolve(authResult);
          // store.dispatch("USER_REQUEST");
        } else if (err) {
          console.log(err.description);
          reject(new Error(err));
        }
      });
    }),
  [AUTH_LOGOUT]: ({ commit, state }) => {
    return new Promise(resolve => {
      commit(AUTH_LOGOUT);

      localStorage.removeItem("Authorization-Token");
      delete axios.defaults.headers.common["Authorization-Token"];

      localStorage.removeItem("expires_at");
      localStorage.removeItem("user");
      localStorage.removeItem("map-user");

      console.log(baseUrl);

      if (state.logoutUrl) {
        const url = new URL(state.logoutUrl)
        url.searchParams.append('return_to', `${window.location.origin}/callback`)
        window.location.replace(url.toString())
      } else {
        window.location.replace(`${loginUrl}/login?return_to=${window.location.origin}/callback`)
      }

      resolve();
    });
  }
};

const mutations = {
  [AUTH_REQUEST]: state => {
    state.status = "loading";
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = "success";
    state.token = resp.token;
    state.hasLoadedOnce = true;
  },
  [AUTH_ERROR]: state => {
    state.status = "error";
    state.hasLoadedOnce = true;
  },
  [AUTH_LOGOUT]: state => {
    state.token = "";
  },
  SET_LOGIUT_URL: (state, url) => {
    state.logoutUrl = url
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
